import React from "react";
import Skills from "../../components/skill/Skils";

const Stack = () => {
  return (
    <section>
    <h3 className="title-font white-text ">
      Here are a few tools & technologies I’ve been working with:
    </h3>
    <Skills />
  </section>
  );
};
export default Stack;
